module.exports = __webpack_public_path__ + "static/media/switch-question.8767a7a3.svg";